import { TFreshRecipe, isFreshRecipe } from "@api-clients/subscriptions";

import { ICatSubscriptionRecord } from "./types/cat-info.types";

export const getAllCatIds = (
  cats: ICatSubscriptionRecord[],
): number[] => cats.map((cat) => cat.details.id);

export const getCatById = (
  cats: ICatSubscriptionRecord[],
  id: number,
): ICatSubscriptionRecord | null => cats.find((cat) => cat.details.id === id) || null;

export const getCatRecipesNames = (
  cat: ICatSubscriptionRecord,
): TFreshRecipe[] => Object.entries(cat.subscription?.recipes ?? [])
  .filter(([ key, value ]) => value && value > 0 && isFreshRecipe(key))
  .map(([ key ]) => key as TFreshRecipe);
